module.exports = __webpack_public_path__ + "img/dashboardIcon2.372a3c25.png";